import { arrayToArrayWithKeyAndValue } from 'helpers';

export const BUTTON_VARIANT_OPTIONS = arrayToArrayWithKeyAndValue(['contained', 'outlined', 'text']);
export const COLOR_OPTIONS = arrayToArrayWithKeyAndValue(['error', 'info', 'warning', 'success', 'primary', 'secondary']);
